import styled from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  lineHeight,
  neutral,
  radius,
  space,
} from '../../../theme/tokens';

export const TaskInstructions = styled.p`
  width: 100%;
  margin: ${space[4]} 0;
  padding: ${space[4]};
  border-radius: ${radius.lg};
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.lg};
  line-height: ${lineHeight.normal};
  color: ${({ theme }) => theme.headerColour};
  background: ${({ theme, isEvidenced }) =>
    isEvidenced ? theme.completedHighlight : neutral.subtle};
  white-space: pre-line;
  overflow-wrap: anywhere;
`;

export * from '../../common/elements/Students';
